import { useEffect, useState } from "react";
import api, { money } from "../../lib/api";
import { PageHeader } from "../../components/PortalShell";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

export default function AdminCredit() {
  const [apps, setApps] = useState([]);
  const load = () => api.get("/credit/applications").then(r => setApps(r.data));
  useEffect(() => { load(); }, []);

  const decide = async (id, status) => {
    await api.patch(`/credit/applications/${id}?status=${status}`);
    toast.success(`Application ${status}`);
    load();
  };

  return (
    <>
      <PageHeader title="Credit Approvals" subtitle="Review Net-30/60/90 applications"/>
      <div className="p-8">
        <div className="rounded-2xl bg-white border border-border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-secondary/50 text-left text-xs uppercase tracking-widest text-foreground/60">
              <tr><th className="px-5 py-3">Buyer</th><th className="px-5 py-3">Amount</th><th className="px-5 py-3">Terms</th><th className="px-5 py-3">Rate</th><th className="px-5 py-3">Status</th><th className="px-5 py-3"/></tr>
            </thead>
            <tbody className="divide-y divide-border">
              {apps.map(a => (
                <tr key={a.id} data-testid={`app-${a.id.slice(0,6)}`}>
                  <td className="px-5 py-4 font-medium">{a.buyer_name}</td>
                  <td className="px-5 py-4 display">{money(a.amount)}</td>
                  <td className="px-5 py-4 uppercase text-xs">{a.terms}</td>
                  <td className="px-5 py-4 mono">{(a.rate*100).toFixed(2)}%</td>
                  <td className="px-5 py-4"><span className={`chip ${a.status==="approved"?"bg-accent/30 border border-accent/40":a.status==="pending"?"bg-secondary":"bg-destructive/10 text-destructive"}`}>{a.status}</span></td>
                  <td className="px-5 py-4 text-right space-x-2">
                    {a.status === "pending" && (
                      <>
                        <Button size="sm" onClick={()=>decide(a.id,"approved")} data-testid={`approve-${a.id.slice(0,6)}`} className="rounded-full bg-foreground text-background hover:bg-foreground/90">Approve</Button>
                        <Button size="sm" variant="outline" onClick={()=>decide(a.id,"declined")} className="rounded-full">Decline</Button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
              {apps.length===0 && <tr><td colSpan={6} className="text-center py-10 text-foreground/60">No applications</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
